module.exports = __webpack_public_path__ + "static/media/  (113).fcf72e52.jpg";